module.exports = __webpack_public_path__ + "static/media/howSection4Image1.ad1c3c94.png";